module.exports = __webpack_public_path__ + "img/10.c3ac2dfb.png";